import axios from 'axios';
import ApiUrl from './config';
import { Gender } from './apiClient';

// Самостоятельная подача заявки на турнир (эндпоинтов ещё нет в сгенерированном apiClient).

export interface CoachOption {
  id: number;
  fullName: string;
}

export interface ApplyPayload {
  tournamentId: number;
  weight: number;
  organization: string;
  coachId?: number;
  rank?: string;
  /** Нужен, только если пол ещё не указан в анкете. */
  gender?: Gender;
  /** Заявка за ребёнка (id его анкеты): доступно только родителю с ролью «Представитель». */
  personId?: number;
}

export async function getCoaches(): Promise<CoachOption[]> {
  const response = await axios.get<CoachOption[]>(`${ApiUrl}/api/Person/GetCoaches`);
  return response.data ?? [];
}

export async function applyToTournament(payload: ApplyPayload): Promise<void> {
  await axios.post(`${ApiUrl}/api/Participant/Apply`, payload);
}

/** personId — отзыв заявки за своего ребёнка (для родителя). */
export async function cancelApplication(tournamentId: number, personId?: number): Promise<void> {
  await axios.delete(`${ApiUrl}/api/Participant/CancelApplication`, { params: { tournamentId, personId } });
}

interface RegistrationWindowSource {
  registrationEndDate?: Date | string;
  isStarted?: boolean;
  isFinished?: boolean;
}

/**
 * Открыта ли регистрация. Последний день регистрации включается целиком (до 23:59 по местному времени),
 * так же считает и сервер (Judo.Controllers.ParticipantController.GetRegistrationClosedMessage).
 */
export function isRegistrationOpen(tournament: RegistrationWindowSource, now: Date = new Date()): boolean {
  if (tournament.isFinished || tournament.isStarted) return false;
  if (!tournament.registrationEndDate) return true;

  const end = new Date(tournament.registrationEndDate);
  if (Number.isNaN(end.getTime())) return true;
  end.setHours(23, 59, 59, 999);
  return now <= end;
}
